/**
 * Internal helpers for the Call Centre services (not exported from the barrel).
 */
/** Return response.data or throw `message` when the envelope carries no data. */
export function unwrapCallCentreResponse(response, message) {
    if (response.data === undefined || response.data === null)
        throw new Error(message);
    return response.data;
}
/** Boolean endpoints (deletes, read / dismiss): the data flag, else the envelope's success. */
export function callCentreOkOrSuccess(response) {
    return response.data ?? response.success;
}
/** Array endpoints: the data, else an empty list. */
export function callCentreListOrEmpty(response) {
    return response.data ?? [];
}
//# sourceMappingURL=unwrapCallCentreResponse.js.map